import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import 'font-awesome/css/font-awesome.min.css';
import { AuthProvider } from './AuthProvider';
import MainContent from './MainContent'; // vamos extrair o MainContent para fora também

function App() {
    return (
        <Router>
            <AuthProvider>
                <MainContent />
            </AuthProvider>
        </Router>
    );
}

export default App;
